// src/components/general/CommonForm.jsx
// Bütün state PARENT səhifədən (Login/Register) props ilə gəlir —
// əvvəllər burada ayrıca useAuth() çağırılırdı və 2 fərqli instansiya
// yaranırdı: parent-in error-ları heç vaxt yenilənmirdi.
import React, { useState } from "react";
import { useI18n } from "../../i18n";

const CommonForm = ({ isLogin, auth }) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const { t } = useI18n();

  const {
    loading,
    name,
    setName,
    phone,
    setPhone,
    password,
    setPassword,
    login,
    register,
    errors,
  } = auth;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLogin) {
      login(e);
    } else {
      register(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {/* Ad Soyad - yalnız qeydiyyat üçün */}
      {!isLogin && (
        <div>
          <label
            className="block text-gray-700 mb-1 text-left"
            htmlFor="fullname"
          >
            {t("auth.fullname")}
          </label>
          <input
            id="fullname"
            type="text"
            name="fullname"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("auth.fullname_placeholder")}
            className="w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none"
          />
          {errors.name && (
            <p className="text-red-500 text-sm mt-1">{errors.name}</p>
          )}
        </div>
      )}

      {/* Telefon */}
      <div>
        <label className="block text-gray-700 mb-1 text-left" htmlFor="phone">
          {t("auth.phone")}
        </label>
        <input
          id="phone"
          type="tel"
          name="phone"
          value={phone}
          placeholder="+994501234567"
          onChange={(e) => setPhone(e.target.value)}
          className="w-full border border-gray-300 rounded-xl px-4 py-2 focus:ring-2 focus:ring-indigo-400 focus:outline-none"
        />
        {errors.phone && (
          <p className="text-red-500 text-sm mt-1">{errors.phone}</p>
        )}
      </div>

      {/* Şifrə */}
      <div className="relative">
        <label
          className="block text-gray-700 mb-1 text-left"
          htmlFor="password"
        >
          {t("auth.password")}
        </label>
        <input
          id="password"
          type={isPasswordVisible ? "text" : "password"}
          name="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="********"
          className="w-full border border-gray-300 rounded-xl px-4 py-2 pr-10 focus:ring-2 focus:ring-indigo-400 focus:outline-none"
        />
        <span
          onClick={() => setPasswordVisible(!isPasswordVisible)}
          className="absolute right-3 top-9 cursor-pointer text-gray-500 select-none"
        >
          {isPasswordVisible ? "🙈" : "👁️"}
        </span>
        {errors.password && (
          <p className="text-red-500 text-sm mt-1">{errors.password}</p>
        )}
      </div>

      {/* Göndər */}
      <button
        type="submit"
        disabled={loading}
        className={`w-full flex gap-3 justify-center items-center bg-gradient-to-r from-indigo-500 to-fuchsia-600 text-white py-3 rounded-xl font-semibold text-lg hover:opacity-90 transition ${
          loading ? "opacity-70 cursor-not-allowed" : ""
        }`}
      >
        {loading && (
          <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
        )}
        <span>{isLogin ? t("auth.submit_login") : t("auth.submit_register")}</span>
      </button>
    </form>
  );
};

export default CommonForm;
